"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAzMapping = getAzMapping;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var axios = new _axios.default({
  extra: {
    componentName: 'AzSelector'
  }
});
// 获取地域可用区
function getAzMapping(data) {
  return axios({
    url: '/openApi/resourcecenter/getAzMapping',
    method: 'POST',
    data: {
      params: data
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/az-selector.js
// module id = 43+c
// module chunks = 19